import React, { useRef, useState, useEffect } from "react";
import Header from "../../layout/Header.js";
import CustomModal from "../../modal/index.js";
import { Button } from "react-bootstrap";
import { decryptJSON, fetchAPI } from "../../service/Encrtyption.js";
import { useForm } from "react-hook-form";
import { json, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { cropValue, login, spinStatus } from "../../auth/redux/store.js";
import { Loader } from "../../loader/index.js";
import { useParams } from "react-router-dom";
import ReactGA from 'react-ga4';
import OTPInput from "react-otp-input";
import { useSelector } from "react-redux";
import { genuityCheckData } from "../../auth/redux/store.js";
import {
    getScanLimitNotice,
    isScanLimitReached,
} from "../../../utils/genuityCheck";
import { parseScanData } from "../../../utils/parseScanData";
import { setOtpVerified } from "../../../utils/otpSession";
import CustomRoulette from "../../WheelComponent/index.js";
import PrivacyConsentContent from "../../pages/privacyConsent/PrivacyConsentContent";
import { getPrivacyConsentNotice } from "../../../content/privacyConsentNotice";
import giftBox from "../../../assets/images/giftBox.png"
import spinBtnHiImg from "../../../assets/images/spinBtnHi.png"
import spinBtnMrImg from "../../../assets/images/spinBtnMr.png"
import spinBtnTeImg from "../../../assets/images/spinBtnTe.png"

const SpinWheel = () => {
    const [selectedCrop, setSelectedCrop] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [GenunityCheckModal, setGenunityCheckModal] = useState(false);
    const [navbarWhite, setNavbarWhite] = useState(false);
    const [errroMsg, setErrorMsg] = useState("");
    const [disableBtn, setDisableBtn] = useState(false);
    const [otpDigits, setOtpDigits] = useState("");
    const [resend, setResend] = useState("");
    const [loading, setLoading] = useState(false);
    const [oTPSec, setOTPSec] = useState(false);
    const [otpValid, setOtpValid] = useState(false);
    const [ErrorModalGenunity, setErrorModalGenunity] = useState(false);
    const [scanErrorResponseData, setscanErrorResponseData] = useState({});
    const [spinModalShow, setSpinModalShow] = useState(false);
    const [stopPrizeNumber, setStopPrizeNumber] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [apiProductName, setApiProductName] = useState("");
    const [productID, setProductID] = useState("");
    const [mobileNumberError, setMobileNumberError] = useState("");
    const [scanedDataObject, setScanedDataObject] = useState(false);
    const [rewardUpdateModal, setRewardUpdateModal] = useState(false);
    const [consentModalShow, setConsentModalShow] = useState(false);
    const [consentAccepted, setConsentAccepted] = useState(false);
    const [pendingSubmitAfterConsent, setPendingSubmitAfterConsent] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [surl, setsurl] = useState('');
    const [name, setName] = useState('');
    const { t, i18n } = useTranslation();
    const { lang } = useParams();
    const currentLanguage = lang;
    const [secondaryRewardMsg, setSecondaryRewardMsg] = useState("");
    const [stepOneClear, setStepOneClear] = useState(false);
    const [stepTwoClear, setStepTwoClear] = useState(false);

    const hide = () => {
        setErrorMsg(""); // Assuming you have a state to manage the error message
    };

    const getSpinButtonImage = () => {
        switch (i18n.language) {
            case "hi":
                return spinBtnHiImg;
            case "mr":
                return spinBtnMrImg;
            case "te":
                return spinBtnTeImg;
            default:
                return spinBtnHiImg;
        }
    };


    //console.log("currentLanguage+"+currentLanguage);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    //login object to send for server
    const productName = sessionStorage.getItem('storedProductName');
    const scanResponseData = useSelector((state) => state?.genunityData);


    ///dat form the store
    const user = useSelector((state) => state?.user);
    const scanedData = useSelector((state) => state?.scandataUrl);
    const genunityData = useSelector((state) => state?.genunityData);
    const giftImageUrl = useSelector((state) => state?.giftImageUrl);
    const [timer, setTimer] = useState(35);
    const [showTimer, setShowTimer] = useState(true);
    const [cropList, setCropList] = useState([]);
    const [wheelItems, setWheelTems] = useState([]);


    const handleSpin = () => {
        ReactGA.event({
            label: "Spin Wheel Button",
            category: "User Spin Wheel",
            action: "Clicked Spin Wheel Button - Spin Wheel Page",
        });
        dispatch(spinStatus(true));
    };

    const handleScanMore = () => {
        // dispatch(spinStatus(true));
    };

    // for close popups'
    const handleCloseModal = () => {
        setSpinModalShow(false);
        setRewardUpdateModal(true);
    };


    return (
        <>
            <Header navbarWhite={navbarWhite} />
            <div className="main px-2 mt-3">
                <div className="container p-0">
                    {loading && <Loader />}

                    <>
                        <div>
                            {/* <img src={bannerLogoSrc} alt="Right" className="spinImgae spinwheelImg" /> */}

                            <div className="d-flex flex-direction-column align-items-center justify-content-center mb-3">
                                <p className="spinCountText">{t('bottleScan')} : <img src={giftBox} alt="giftBox" className="giftBox img-fluid mr-1" /> {scanResponseData.scanCount} </p>
                            </div>

                            <CustomRoulette
                                wheelItems={scanResponseData.wheelItems}
                                stopPrizeNumber={stopPrizeNumber}
                                closeModal={handleCloseModal}
                                spinInnerImage={scanResponseData.centerWheelImgUrl}
                            />

                        </div>

                        <img src={getSpinButtonImage()} alt="spinBtn" className="spinBtnimg d-block mx-auto mt-3" onClick={handleSpin} />

                        <div className="d-flex flex-direction-column bottomBtns" style={{ gap: "1rem" }}>

                            <Button className="rounded-4 py-2 btnshadow btn-secondary mx-auto" style={{ width: "90%" }}
                                onClick={() => {

                                    ReactGA.event({
                                        category: 'Scan More', 
                                        label: 'User Scan More',
                                        action: 'Clicked Scan More Button - SpinWheel Page'
                                    });

                                    navigate(`/${lang}/scanProduct`);
                                }}>
                                {t("Scanmore")}
                            </Button>


                        </div>


                        {/* <Button onClick={handleSpin} className="m-auto rounded-4 py-2 btnshadow btn-secondary" style={{ width: '93%' }}>
                            {t("Scanmore")}
                        </Button>

                        <Button onClick={handleSpin} className="m-auto rounded-4 py-2 btnshadow btn-secondary" style={{ width: '93%' }}>
                            {t('rewardJourney.proceed')}
                        </Button> */}

                    </>

                </div>
                {errorMessage && (
                    <div
                        className="alert alert-warning alert-dismissible fade show mt-2"
                        role="alert"
                    >
                        {errorMessage}
                        <button
                            type="button"
                            className="close"
                            onClick={hide}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default SpinWheel;
